import React from 'react';
import type { Props } from 'recharts/types/component/Label';

const UNITS_TO_REMOVE = 10;
const DECIMAL_X_TO_REMOVE = 30;
const DEFAULT_X_TO_REMOVE = 6;
export const BarChartCustomRightLabel: React.FC<Readonly<Props>> = ({
  x,
  y,
  value,
  width,
  fontSize,
  color,
}) => {
  const isNA = value === 'N/A';
  if (!isNA && (!x || !y || !value)) return null;

  const parsedValue = String(value);
  const hasMoreThanOneUnit = parsedValue.length > 1;
  const labelYPosition = Number(y) - UNITS_TO_REMOVE;
  const labelXPosition = Number(x) + Number(width);

  const getRemainingWidth = () => {
    if (hasMoreThanOneUnit) return DECIMAL_X_TO_REMOVE;

    return DEFAULT_X_TO_REMOVE;
  };

  return (
    <text
      x={labelXPosition - getRemainingWidth()} // Position at the end of the bar
      y={labelYPosition}
      fill={color}
      fontSize={fontSize || 12}
      className="mr-1"
      textAnchor="start"
    >
      {value}
    </text>
  );
};
